import { useEffect, useRef, useState } from "react";
import { AlarmRinging } from "./components/AlarmRinging";
import { Alarms } from "./components/Alarms";
import { Analytics } from "./components/Analytics";
import { AudioItem } from "./components/AudioItem";
import { Clock } from "./components/Clock";
import { PlusIcon } from "./components/icons/PlusIcon";
import { InfoBox } from "./components/InfoBox";
import { Layout } from "./components/Layout";
import { Modal } from "./components/Modal";
import { OptionsModal } from "./components/OptionsModal";
import { SilentAudioItem } from "./components/SilentAudioItem";
import { Titlebar } from "./components/Titlebar";

const __options__ = {
  showAnalogClock: true,
  showDigitalClock: true,
  saveAlarms: true,
  keepAwake: false,
};

const App = () => {
  const [alarms, setAlarms] = useState(
    JSON.parse(localStorage.getItem("kikirikiAlarms") ?? "[]")
  );
  const [formVisible, setFormVisible] = useState(!alarms.length);
  const [optionsModalVisible, setOptionsModalVisible] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [ringingAlarm, setRingingAlarm] = useState(null);
  const [options, setOptions] = useState(__options__);
  const [soundToPlay, setSoundToPlay] = useState("");
  const [soundPlaying, setSoundPlaying] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  const workerRef = useRef();

  useEffect(() => {
    // workerRef.current = new Worker(new URL("./worker.js", window.location.host));
    workerRef.current = new Worker("./worker.js");

    workerRef.current.onmessage = (e) => {
      console.log(e);

      let date = new Date();
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();

      alarms?.forEach((alarm) => {
        if (alarm.hours === h && alarm.minutes === m && alarm.seconds === s) {
          setRingingAlarm((prev) => {
            if (prev) {
              // kane stop edw kai source change
            }

            return alarm;
          });
        }
      });
    };
    workerRef.current.postMessage("start");

    return () => {
      workerRef.current.postMessage("stop");
      workerRef.current?.terminate();
    };
  }, [alarms]);

  // useEffect(() => {
  //   let interval = null;

  //   if (alarms.length) {
  //     interval = setInterval(() => {
  //       let date = new Date();
  //       let h = date.getHours();
  //       let m = date.getMinutes();
  //       let s = date.getSeconds();

  //       alarms.forEach((alarm) => {
  //         if (alarm.hours === h && alarm.minutes === m && alarm.seconds === s) {
  //           setRingingAlarm((prev) => {
  //             if (prev) {
  //               // kane stop edw kai source change
  //             }

  //             return alarm;
  //           });
  //         }
  //       });
  //     }, 1000);
  //   }

  //   return () => {
  //     if (interval) clearInterval(interval);
  //   };
  // }, [alarms]);

  useEffect(() => {
    if (ringingAlarm) {
      setSoundToPlay(() => ringingAlarm.sound);
      setSoundPlaying(() => true);
    } else {
      setSoundToPlay("");
      setSoundPlaying(false);
    }
  }, [ringingAlarm]);

  useEffect(() => {
    if (options.saveAlarms) {
      localStorage.setItem("kikirikiAlarms", JSON.stringify(alarms));
    } else {
      localStorage.removeItem("kikirikiAlarms");
    }
  }, [options.saveAlarms, alarms]);

  const toggle = () => {
    setFormVisible((p) => !p);
    editItem && setEditItem(null);
  };

  const toggleOptions = () => {
    setOptionsModalVisible((p) => !p);
  };

  const addAlarm = ({
    hours,
    minutes,
    seconds,
    label = "",
    color = "",
    sound = "",
  }) => {
    setAlarms((prev) => {
      let items = prev;

      if (editItem) {
        items = items.filter((item) => item.id !== editItem.id);
      }

      if (
        items.filter((p) => p.hours === hours && p.minutes === minutes).length
      ) {
        return items;
      }

      items = [
        ...items,
        {
          id: `${items.length + 1}-${hours}-${minutes}`,
          hours,
          minutes,
          seconds,
          label,
          color,
          sound: sound || "classic",
        },
      ];

      if (options.saveAlarms) {
        localStorage.setItem("kikirikiAlarms", JSON.stringify(items));
      }
      return items;
    });
  };

  const addEditItem = (item) => {
    setEditItem(() => item);
    toggle();
  };

  const onDelete = (id) => {
    setAlarms((prev) => {
      let items = prev.filter((item) => item.id !== id);

      if (options.saveAlarms) {
        localStorage.setItem("kikirikiAlarms", JSON.stringify(items));
      }
      return items;
    });
  };

  const updateOptions = (option) => {
    setOptions((prev) => ({ ...prev, ...option }));
    toggleOptions();
  };

  const addBtnStyle = {
    backgroundColor: "#00000033",
    padding: 20,
    border: "2px dashed white",
    borderRadius: ".5em",
    marginTop: 20,
    fontSize: 20,
    color: "white",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <Layout>
      {options.keepAwake && <SilentAudioItem />}
      <InfoBox showInfo={showInfo} setShowInfo={setShowInfo} />
      <Analytics />
      <AudioItem audio={soundToPlay} shouldPlay={soundPlaying} />
      <AlarmRinging
        alarm={ringingAlarm}
        dismiss={setRingingAlarm}
        soundPlaying={soundPlaying}
        soundToPlay={soundToPlay}
        setSoundToPlay={setSoundToPlay}
        setSoundPlaying={setSoundPlaying}
      />
      <Titlebar
        toggle={toggle}
        toggleOptions={toggleOptions}
        setShowInfo={setShowInfo}
      />
      <Clock options={options} />
      <button style={addBtnStyle} onClick={toggle}>
        <PlusIcon fill="var(--light)" /> Add new alarm
      </button>
      {/* {!!alarms.length && ( */}
      <div className="calmalama-container">
        <p className="title">✨ It's here! The new & improved calmalama!</p>
        <p className="text">
          We've been listening to your feedback and working hard behind the
          scenes. Calmalama is a complete upgrade of the Kikiriki experience,
          smarter tools, a cleaner design, and more control over your focus
          routines. Your favorite features are back, and better than ever.
        </p>
        <a
          className="link"
          href={`https://calmalama.com/app/alarms/sync/kikiriki?alarms=${JSON.stringify(
            alarms
          )}`}
        >
          🚀 Try the new Calmalama now, your focus will thank you!
        </a>
      </div>
      {/* )} */}
      <Alarms alarms={alarms} addEditItem={addEditItem} onDelete={onDelete} />
      <Modal
        onClose={toggle}
        onSubmit={addAlarm}
        visible={formVisible}
        editItem={editItem}
        soundPlaying={soundPlaying}
        soundToPlay={soundToPlay}
        setSoundToPlay={setSoundToPlay}
        setSoundPlaying={setSoundPlaying}
      />
      <OptionsModal
        onClose={toggleOptions}
        onSubmit={updateOptions}
        visible={optionsModalVisible}
        options={options}
      />
      <div
        className="fb-like"
        data-href="https://www.facebook.com/kikirikiOnlineAlarmClock"
        data-width=""
        data-layout="button_count"
        data-action="like"
        data-size="small"
        data-share="true"
        data-colorscheme="dark"
      ></div>
      <a target="new" className="privacy" href="/privacy-policy.html">
        Privacy policy
      </a>
      {/* <a target="new" className="privacy" href="/old">
        Go to the old website
      </a> */}
    </Layout>
  );
};

export default App;
